import BlockQuote from './BlockQuote.vue'
import BlockTakeaway from './BlockTakeaway.vue'
import BlockInterview from './BlockInterview.vue'
import BlockMedia from './BlockMedia.vue'
import BodyVideo from './BodyVideo.vue'
import FaqItems from '../FaqItems/FaqItems.vue'

const basePortableTypes = {
	quoteBlock: BlockQuote,
	takeawayBlock: BlockTakeaway,
	interviewBlock: BlockInterview,
	youtubeEmbed: BodyVideo,
	imageAsset: BlockMedia,
	videoAsset: BodyVideo,
	faqItems: FaqItems,
}

export function createBodyPortableComponents(typeOverrides = {}) {
	return {
		types: {
			...basePortableTypes,
			...typeOverrides,
		},
	}
}
